var _defs, _path, _path2, _ellipse, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateversion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 191 133.959"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "updateversion_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2dc0f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#28c0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#23c0e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1ec1df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#19c1d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#14c1cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0fc2c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0ac2bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#05c2b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c3af"
  })), /*#__PURE__*/React.createElement("style", null, ".updateversion_svg__a{fill:#0c263d}.updateversion_svg__c{fill:#3f3d56}.updateversion_svg__d{fill:#ffb8b8}.updateversion_svg__e{fill:#2f2e41}.updateversion_svg__h{fill:#d0cde1}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__a",
    d: "M28.366 112.292l-.238-.089c-.052-.02-5.253-2.012-7.689-6.53s-1.243-9.958-1.231-10.012l.056-.248.238.089c.052.02 5.253 2.012 7.689 6.53s1.243 9.958 1.231 10.012zm-7.537-6.83c2.06 3.82 6.169 5.778 7.211 6.225.2-1.116.819-5.629-1.239-9.445s-6.169-5.777-7.211-6.225c-.198 1.117-.819 5.629 1.239 9.445z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.301 104.307c4.378 2.634 6.064 7.866 6.064 7.866s-5.412.961-9.79-1.673-6.064-7.866-6.064-7.866 5.413-.959 9.79 1.673z",
    fill: "#00c3ae"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "updateversion_svg__c",
    cx: 15.952,
    cy: 3.545,
    rx: 15.952,
    ry: 3.545,
    transform: "translate(141.384 60.375)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__a",
    d: "M123.476 112.1l16.61-42.09.412.163-16.61 42.09zM173.97 70.111l.412-.163L191 112.045l-.412.163zM156.894 70.056h.443v42.097h-.443zM137.477 85.557l.198-.396 16.83 8.415-.198.396zM159.897 93.582l16.83-8.415.198.396-16.83 8.415z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__d",
    d: "M135.773 38.819s-6.647-6.868-8.419-2.659 6.647 6.425 6.647 6.425z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__e",
    d: "M149.914 50.685l-8.641 12.407-9.084 12.629-2.659 36.558 9.084 1.108s-1.329-9.97 1.108-15.952 2.437-16.839 2.437-16.839l15.73-19.055 8.862 15.288 9.527 36.558 7.976-.665s-2.88-16.839-2.437-18.611-4.653-16.617-4.653-16.617l-3.988-29.024s-18.166-2.66-23.262 2.215z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "updateversion_svg__d",
    cx: 6.367,
    cy: 6.367,
    r: 6.367,
    transform: "translate(147.457 5.368)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__d",
    d: "M157.891 13.847l4.653 4.874 1.329 7.533-11.743 1.994.886-6.868s-.222-3.323-1.108-3.988 5.983-3.545 5.983-3.545z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M887.969 191.825l1.079-1.219 3.573 3.213 5.982-5.539 9.084 30.575a16.312 16.312 0 00-11.3.665c-5.539 2.659-12.851 1.994-12.851 1.994l.222-24.815z",
    transform: "translate(-736.06 -169.558)",
    fill: "url(#updateversion_svg__a)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__h",
    d: "M145.656 27.09l7.424-6.791s2.547 3.69 1.439 10.78-1.994 21.048-5.982 24.815-5.539 5.1-5.539 5.1l3.988-15.952s-3.102-16.18-1.33-17.952zM160.419 16.495s13.2-1.319 13.425.232-1.329 19.276-1.329 19.276 13.737 18.39 7.976 21.935c-2.686 1.653-5.008-1.978-8.309-6.536-3.778-5.217-8.4-11.763-8.752-14.955-.664-5.981-3.011-19.952-3.011-19.952z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__h",
    d: "M146.354 33.279l-1.108 8.641-9.749-4.21-3.1 6.425 15.952 5.982s2.879-15.287-1.995-16.838z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__e",
    d: "M130.679 111.102l-6.421 10.413s-12.186 6.647-7.976 8.419 14.4-1.994 15.509-4.21 1.551-2.659 1.994-2.216 5.982-1.329 6.2-1.994 0-8.2-1.994-9.084-7.312-1.328-7.312-1.328zM176.502 112.209l1.329 8.2 1.551 5.76s1.108 8.419 6.425 7.755a4.294 4.294 0 003.877-4.016 8.039 8.039 0 00-.888-4.98l-2.989-5.627-2.659-7.533zM147.459 12.9a3.119 3.119 0 01-.777-2.1 6.674 6.674 0 00-.126-1.988 19.633 19.633 0 01.671-3.024c.4-1.11.063-1.5 1.782-2.1s.625-2.8 5.692-1.05a1.386 1.386 0 001.508.309c.936-.343 1.5.943 1.5.943s.584-.479.911.019 1.911-.637 2.492 2.985a11.166 11.166 0 01-1.413 6.851s-.28-5.795-3.571-5.9-7.013-1.352-7.474 1.089a17.812 17.812 0 01-1.195 3.966z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__d",
    d: "M170.364 46.127s-7.993 5.241-4.19 7.772 7.558-5.324 7.558-5.324z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__h",
    d: "M172.292 16.727a1.745 1.745 0 012.659 1.108c.665 2.216 7.533 19.276 7.533 19.276l-8.641 13.294-6.2-4.431 7.533-8.862-5.1-6.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__c",
    d: "M131.052 20.609h-.232v-6.354a3.677 3.677 0 00-3.677-3.677h-13.462a3.677 3.677 0 00-3.677 3.677v34.858a3.677 3.677 0 003.677 3.677h13.466a3.677 3.677 0 003.677-3.677V25.131h.232z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M127.206 11.62h-1.757a1.3 1.3 0 01-1.208 1.8h-7.712a1.3 1.3 0 01-1.208-1.8h-1.641a2.746 2.746 0 00-2.746 2.746v34.807a2.746 2.746 0 002.746 2.746h13.526a2.746 2.746 0 002.746-2.746V14.366a2.746 2.746 0 00-2.746-2.746z",
    fill: "#00afff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__a",
    d: "M120.403 28.55l2.89 5.005 2.89 5.005h-11.56l2.89-5.005z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__h",
    d: "M120.396 32.169l1.311 2.271 1.311 2.271h-5.244l1.311-2.271zM120.396 24.799l1.311 2.271 1.311 2.27h-5.244l1.311-2.27z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__a",
    d: "M64.455 46.18L83.519 79.2l19.064 33.02H26.327L45.391 79.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__h",
    d: "M64.109 70.086l8.648 14.979 8.648 14.981H46.813l8.648-14.979zM64.109 21.488l8.644 14.98 8.648 14.979H46.813l8.648-14.979z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "updateversion_svg__a",
    d: "M0 111.876h124.296v.443H0zM38.33 27.117a13.38 13.38 0 01-2.107-3.788 13.392 13.392 0 01-2.107 3.788l1.886-.682v9.967h.443v-9.967zM98.716 60.177a13.379 13.379 0 01-2.107-3.788 13.393 13.393 0 01-2.107 3.788l1.886-.682v9.967h.443v-9.967zM79.75 3.787a13.379 13.379 0 01-2.107-3.788 13.391 13.391 0 01-2.107 3.788l1.886-.682v9.967h.443V3.105z"
  })));
}
export var url = __webpack_public_path__ + "6a547a91d1512440c5f78a33720af5ef.svg";
;
export default SvgUpdateversion;